import { render, staticRenderFns } from "./AgentTransactionDetails.vue?vue&type=template&id=4f560dd7&scoped=true&"
import script from "./AgentTransactionDetails.vue?vue&type=script&lang=js&"
export * from "./AgentTransactionDetails.vue?vue&type=script&lang=js&"
import style0 from "./AgentTransactionDetails.vue?vue&type=style&index=0&id=4f560dd7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f560dd7",
  null
  
)

export default component.exports